import React from 'react';
import SkeletonBlock from '../ui/SkeletonBlock';
import SkeletonRoot from '../ui/SkeletonRoot';
import {
  adminFilterToolbarClass,
  adminListTableShellClass,
  adminListTableSkeletonHeaderClass,
  adminListTableSkeletonRowClass,
} from '../../utils/admin/adminChrome';

/**
 * Layout-faithful investors page skeleton — header, tabs, filters, table.
 */
const InvestorsSkeleton: React.FC = () => (
  <SkeletonRoot loadingLabel="Loading investors">
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-[1400px] px-4 py-4 sm:px-6 lg:px-8">
        <div className="mb-4 space-y-4">
          <SkeletonBlock className="h-9 w-64 rounded-lg" />
          <div className="flex gap-2">
            <SkeletonBlock className="h-10 w-36 rounded-lg" />
            <SkeletonBlock className="h-10 w-32 rounded-lg" />
          </div>
          <div className={adminFilterToolbarClass}>
            <SkeletonBlock className="h-9 min-w-[200px] flex-1 max-w-sm rounded-lg" />
            <SkeletonBlock className="h-9 w-[180px] rounded-lg" />
            <SkeletonBlock className="ml-auto h-9 w-[130px] rounded-lg" />
          </div>
        </div>

        <div className={adminListTableShellClass}>
          <div className={adminListTableSkeletonHeaderClass}>
            <div className="flex gap-4">
              {Array.from({ length: 6 }).map((_, i) => (
                <SkeletonBlock key={i} className="h-4 flex-1" />
              ))}
            </div>
          </div>
          {Array.from({ length: 10 }).map((_, i) => (
            <div key={i} className={adminListTableSkeletonRowClass}>
              <SkeletonBlock className="h-4 w-36" />
              <SkeletonBlock className="h-4 w-24" />
              <SkeletonBlock className="h-4 w-20" />
              <SkeletonBlock className="h-4 w-16" />
              <SkeletonBlock className="ml-auto h-8 w-20 rounded" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </SkeletonRoot>
);

export default InvestorsSkeleton;
